import * as Dialog from "@radix-ui/react-dialog";
import { keyframes, styled } from "@pigment-css/react";

const overlayIn = keyframes({ from: { opacity: 0 }, to: { opacity: 1 } });
const overlayOut = keyframes({ from: { opacity: 1 }, to: { opacity: 0 } });

export const DimOverlay = styled(Dialog.Overlay)(({ theme }) => ({
  position: "fixed",
  inset: 0,
  // Same z-index as sheet content: DOM order keeps the overlay under its own sheet, while a
  // nested sheet's overlay (mounted later) still dims the host sheet beneath it.
  zIndex: 1101,
  background: theme.fieldSalesTwo.colors.neutral[400],
  '&[data-state="open"]': {
    animation: `${overlayIn} ${theme.fieldSalesTwo.motion.duration.base} ${theme.fieldSalesTwo.motion.easing.standard}`,
  },
  '&[data-state="closed"]': {
    animation: `${overlayOut} ${theme.fieldSalesTwo.motion.duration.sheetOut} ${theme.fieldSalesTwo.motion.easing.standard}`,
  },
}));
